import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { filter, flatMap, take } from 'rxjs/operators';
import { IReviewRequestDataResolveData } from '../review-data.data';
import { ReviewDataStore } from '../review-data.store';
import { ReviewDataDispatcher } from '../review-data.dispatcher';
import { ReviewRequest } from '../models/review-request.model';
import { NavigationService } from 'i2g-ng-utils';
import { REVIEW_REQUEST_PATH } from '../../settings/settings.data';

@Injectable()
export class ReviewRequestDataResolve
  implements Resolve<IReviewRequestDataResolveData> {
  static RESOLVE = {
    reviewRequestData: ReviewRequestDataResolve,
  };

  constructor(
    private _reviewDataStore: ReviewDataStore,
    private _reviewDataDispatcher: ReviewDataDispatcher,
    private _navigationService: NavigationService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IReviewRequestDataResolveData> {
    const clientId = route.paramMap.get('id');

    this._reviewDataDispatcher.requestReview(clientId);

    return this._reviewDataStore.reviewRequest$.pipe(
      filter<ReviewRequest>(Boolean),
      take(1),
      flatMap((reviewRequest) => {
        if (reviewRequest) {
          return of({ reviewRequest });
        } else {
          this._navigationService.goTo(REVIEW_REQUEST_PATH);
          return EMPTY;
        }
      })
    );
  }
}
